import { NotificationEnum, NotificationModel } from '@arpeggi/shared'
import {
  ArpFavoritedNotificationType,
  ArpUsedNotificationType,
  MintCompletedNotificationType
} from './notifications'

export const isUsedNotification = (
  notification: NotificationModel
): notification is ArpUsedNotificationType => {
  return notification.data.type === NotificationEnum.ARP_USED
}

export const isMintedNotification = (
  notification: NotificationModel
): notification is MintCompletedNotificationType => {
  return notification.data.type === NotificationEnum.MINT_COMPLETED
}

export const isFavoritedNotification = (
  notification: NotificationModel
): notification is ArpFavoritedNotificationType => {
  return notification.data.type === NotificationEnum.ARP_FAVORITED
}
